var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperlinkGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 3.5V4.66667H2.91667V11.0833H9.33333V8.16667H10.5V11.6667C10.5 11.8214 10.4385 11.9697 10.3291 12.0791C10.2197 12.1885 10.0714 12.25 9.91667 12.25H2.33333C2.17862 12.25 2.03025 12.1885 1.92085 12.0791C1.81146 11.9697 1.75 11.8214 1.75 11.6667V4.08333C1.75 3.92862 1.81146 3.78025 1.92085 3.67085C2.03025 3.56146 2.17862 3.5 2.33333 3.5H5.83333ZM12.25 1.75V7L10.0368 4.78742L6.53742 8.28742L5.71258 7.46258L9.212 3.96258L7 1.75H12.25Z",
    fill: "#080917"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlinkGrey);
export default __webpack_public_path__ + "static/media/hyperlink-grey.8d7dc84341d76107ee0628965960f474.svg";
export { ForwardRef as ReactComponent };